export enum ProductCodes {
  Eargo5FullSystem = "99-0114-001",
  Eargo5LeftHI = "04-0141-001",
  Eargo5RightHI = "04-0141-002",
  Eargo5Charger = "04-0272",
  Eargo5Charger2 = "04-0156",
  Eargo5LeftHI2 = "99-0126-001",
  Eargo5RightHI2 = "99-0127-001",
  Eargo6FullSystem = "99-0147-001",
  Eargo6LeftHI = "04-0290-001",
  Eargo6RightHI = "04-0290-002",
  Eargo6LeftHI2 = "99-0149-001",
  Eargo6RightHI2 = "99-0150-001",
  Eargo7FullSystem = "99-0156-001",
  Eargo7LeftHI = "04-0313-001",
  Eargo7RightHI = "04-0313-002",
  Eargo7LeftHI2 = "99-0157-001",
  Eargo7RightHI2 = "99-0158-001",
  Eargo8FullSystem = "99-0179-001",
  Eargo8LeftHI = "04-0301-003",
  Eargo8RightHI = "04-0301-004",
  Eargo8LeftHI2 = "99-0180-001",
  Eargo8RightHI2 = "99-0181-001",
  EargoSEFullSystem = "99-0155-001",
  EargoSELeftHI = "04-0301-001",
  EargoSERightHI = "04-0301-002",
  EargoSELeftHI2 = "99-0159-001",
  EargoSERightHI2 = "99-0160-001",
  UniversalCharger = "04-0270",
  UniversalCharger2 = "99-0128-001",
  UniversalCharger3 = "99-0141-001",
  UniversalCharger4 = "99-0146-001",
}
